import http from '../common/http-auth'
import type { TemplateTestSendEmail } from 'src/components/types/types';


// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAlltemplate = async (clientId?: number) => {
    // Explicitly handle null, undefined, 0, and NaN cases
    const url = (clientId != null && !isNaN(clientId) && clientId !== 0) ? `/template/all?clientId=${clientId}` : '/template/all';
    // Send the GET request
    const response = await http.get(url);
    // Return the response
    return response;
}


// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const addtemplate = async (formData: FormData) => {
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            // Add any other required headers your API needs
        }
    };

    try {
        const response = await http.post(`/template/add`, formData, config);
        return response;
    } catch (error) {
        throw error;
    }
};


// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const deletetemplate= async (data: any) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const response = http.delete(`/template/delete`, {data: data})
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const updatestatus = async (data: any, formData: any) => {
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            // Add any other required headers your API needs
        }
    };
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-unsafe-member-access
    const response = http.put(`/template/status?id=${data.id}&status=${data.status}&message=${data.message}&templateVersion=${data.templateVersion}&updatedBy=${data.updatedBy}`, formData, config);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const submitapproval = async (id: number, requestedBy: number) => {
    const response = http.put(`/template/submitapproval?id=${id}&requestedBy=${requestedBy}`)
    return response;
}


// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const updatetemplate = async (formData: FormData) => {
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            // Add any other required headers your API needs
        }
    };

    try {
        const response = await http.put(`/template/update`, formData, config);
        return response;
    } catch (error) {
        throw error;
    }
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const copytemplate = async (id: number, createdBy: number) => {
    const response = await http.post(`/template/copy?id=${id}&createdBy=${createdBy}`);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const gettemplateById = async (id: string) => {
    const response = http.get(`/template/${id}`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const gettemplateImageList = async (templateIdentifier: string,templateVersion:number, createdBy: number) => {
    const response = http.get(`/template/blobstorageimagelist?templateIdentifier=${templateIdentifier}&templateVersion=${templateVersion}&createdBy=${createdBy}`)
    return response;
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const updatetemplateimages = async (formData: FormData,templateIdentifier: string,templateVersion:number, createdBy: number) => {
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            // Add any other required headers your API needs
        }
    };

    try {
        const response = await http.post(`/template/uploadtemplateimagetoblob?templateIdentifier=${templateIdentifier}&templateVersion=${templateVersion}&createdBy=${createdBy}`, formData, config);
        return response;
    } catch (error) {
        throw error;
    }
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const sendTestEmail = async (data: TemplateTestSendEmail) => {
    const response = await http.post(`/testemail/fromtemplateui`, data);
    return response;
}



// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const gettemplateVersionList = async (templateIdentifier: string) => {
    const response = http.get(`/template/gettemplateversion?templateIdentifier=${templateIdentifier}`)
    return response;
}



// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const updateTemplateVersion = async (templateIdentifier: string,templateVersionId:number,updatedBy:number) => {
    const response = http.put(`/template/updatetemplateversion?templateIdentifier=${templateIdentifier}&templateVersionId=${templateVersionId}&updatedBy=${updatedBy}`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getTemplateCommentHistory = async (templateId: number) => {
    const response = http.get(`/template/gettemplateapprovalcomment?templateId=${templateId}`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getTemplateContent = async (campaignType: string, id: string | number) => {
    const response = await http.get(`/template/gettemplatecontent?campaignType=${campaignType}&id=${id}`);
    return response;
};